import React from "react"

const MenuPointer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M6.60801 0.855476C6.06065 1.14218 5.65842 1.71476 5.26831 2.46224C4.87318 3.21935 4.43915 4.26347 3.87817 5.61299L3.8678 5.63793L2.03071 10.0573L2.02093 10.0808C1.65099 10.9707 1.36029 11.67 1.18166 12.2379C1.00117 12.8117 0.912483 13.3167 1.00395 13.8037C1.15468 14.6063 1.62607 15.3128 2.30932 15.76C2.72392 16.0314 3.22427 16.1434 3.8234 16.197C4.41633 16.25 5.17364 16.25 6.13737 16.25H6.1629H9.83709H9.86263C10.8264 16.25 11.5837 16.25 12.1766 16.197C12.7757 16.1434 13.2761 16.0314 13.6907 15.76C14.3739 15.3128 14.8453 14.6063 14.9961 13.8037C15.0875 13.3167 14.9988 12.8117 14.8183 12.2379C14.6397 11.67 14.349 10.9707 13.9791 10.0808L13.9693 10.0573L12.1322 5.63793L12.1218 5.61303C11.5609 4.26349 11.1268 3.21936 10.7317 2.46224C10.3416 1.71476 9.93935 1.14218 9.39199 0.855477C8.52018 0.398823 7.47982 0.398823 6.60801 0.855476Z"
        fill="white"
        stroke="#F2F4F7"
      />
    </svg>
  )
}

export default MenuPointer
